import React from "react";
import clsx from "clsx";

import styles from "./LiveBadge.module.css";

interface IProps {
    label: string;
    className?: string;
}

const LiveBadge: React.FC<IProps> = ({label, className}) => (
    <span className={clsx(styles.badge, className)}>
        <span className={styles.dot}/>
        {label}
    </span>
);

export default LiveBadge;
